var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._g(_vm._b({ref:"field",attrs:{"outlined":"","data-cy":_vm.dataCy}},'v-textarea',Object.assign({}, {rows: 6},
        _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }